import { menuAction } from "../const";
export const getMenu = (data: any) => {
    return {
        type: menuAction.GET_MENU,
        payload: data,
    };
};
